import { render, staticRenderFns } from "./BpDataTable.vue?vue&type=template&id=7bf2e6f2&scoped=true&"
import script from "./BpDataTable.vue?vue&type=script&lang=js&"
export * from "./BpDataTable.vue?vue&type=script&lang=js&"
import style0 from "./BpDataTable.vue?vue&type=style&index=0&id=7bf2e6f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf2e6f2",
  null
  
)

export default component.exports